module.exports = __webpack_public_path__ + "img/cns_android7.3131df36.png";